// extracted by mini-css-extract-plugin
module.exports = {"root":"_22c443fa"};